import { Injectable } from '@angular/core';

const TOKEN_KEY = 'CesarAuthToken';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor() {}

  // Saves the auth token
  saveToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  }

  // Gets the token
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  // Deletes the token
  removeToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  }

  // Checks if the user has already logged in
  isAuthenticated(): boolean {
    const token = this.getToken();
    // Checks if the token is there and if it's not expired
    return !!token && !this.isTokenExpired(token);
  }

  // Checks if the token is expired
  isTokenExpired(token: string): boolean {
    // Recup la date actuelle
    const currentTime = new Date().getTime() / 1000; // Convertis en secondes

    // Extracting the expiration date by analysing the token
    const tokenData = this.parseToken(token);

    if (tokenData && tokenData.exp) {
      // Comparing the token's expiration date with the actual one
      return tokenData.exp < currentTime;
    }

    // If the token doesn't have any info about its expiration time, considering it expired
    return true;
  }

  parseToken(token: string): any {
    try {
      // Analysing the token to get the data from it.
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      return tokenData;
    } catch (error) {
      // TODO:Gérer les erreurs de parsing ici
      return null;
    }
  }
}
